import { Injectable } from '@angular/core';
import { Library, Loader } from '@googlemaps/js-api-loader';
import { environment } from '../../../environments/environment';
import { isLanguageCodeSupported } from '../data/languages.data';

@Injectable({
  providedIn: 'root',
})
export class GoogleLibraryLoaderService {
  private readonly userLanguage: string = '';
  private loader: Loader;

  constructor() {
    this.loader = new Loader({
      apiKey: environment.googleMapsApiKey,
      version: 'weekly',
      libraries: ['places'],
      language: this.userLanguage,
    });
    this.userLanguage = isLanguageCodeSupported(
      window.localStorage.getItem('language') || ''
    )
      ? <string>window.localStorage.getItem('language')
      : 'en-GB';
  }

  initMapLoader() {
    this.loader.importLibrary('maps').catch((error) => {
      console.error(error);
    });
  }

  importLibrary(name: Library): Promise<any> {
    return this.loader.importLibrary(name);
  }
}
